module.exports = __webpack_public_path__ + "img/v5.7b6be451.png";